import { render } from "./PromotionListComponent.vue?vue&type=template&id=2af84780&scoped=true"
import script from "./PromotionListComponent.vue?vue&type=script&lang=js"
export * from "./PromotionListComponent.vue?vue&type=script&lang=js"

import "./PromotionListComponent.vue?vue&type=style&index=0&id=2af84780&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af84780"],['__file',"resources/js/components/admin/promotions/PromotionListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2af84780"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2af84780', __exports__)) {
    api.reload('2af84780', __exports__)
  }
  
  module.hot.accept("./PromotionListComponent.vue?vue&type=template&id=2af84780&scoped=true", () => {
    api.rerender('2af84780', render)
  })

}


export default __exports__